import {
  validateProxyConfig,
  type PersonalProxyConfig,
} from "./transports/PersonalProxyTransport.ts";

export interface NetworkSettings {
  workerEnabled: boolean;
  workerPreferred?: boolean;
  imageProxyEnabled: boolean;
  personalProxy?: PersonalProxyConfig;
}
const defaults: NetworkSettings = { workerEnabled: false, imageProxyEnabled: false };
let fallback: NetworkSettings = { ...defaults };

export function getNetworkSettings(): NetworkSettings {
  try {
    const raw = JSON.parse(localStorage.getItem("yomiri_network_settings") ?? "null");
    if (!raw || typeof raw !== "object") return { ...fallback };
    const result: NetworkSettings = {
      workerEnabled: false,
      workerPreferred: false,
      imageProxyEnabled: raw.imageProxyEnabled === true,
    };
    if (raw.personalProxy) {
      validateProxyConfig(raw.personalProxy);
      result.personalProxy = raw.personalProxy;
    }
    return result;
  } catch {
    return { ...fallback };
  }
}

export function setNetworkSettings(settings: NetworkSettings): void {
  if (settings.personalProxy) validateProxyConfig(settings.personalProxy);
  settings = { ...settings, workerEnabled: false, workerPreferred: false, imageProxyEnabled: false };
  fallback = structuredClone(settings);
  try {
    localStorage.setItem("yomiri_network_settings", JSON.stringify(settings));
  } catch {
    /* Session-only settings still work. */
  }
  if (typeof window !== "undefined") window.dispatchEvent(new Event("yomiri-transport-changed"));
}
